import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 50vw;
  min-height: 20vh;
  max-width: 60vw;
  max-height: 95vh;
`;

const Header = styled.div`
  display: flex;
  // justify-content: center;
  align-items: center;
  // flex-direction: column;
`;

const HeroText = styled.h2`
  font-size: 1.8em;
  font-weight: 800;
  margin: 0;
  padding: 0;
`;

const MainText = styled.p`
  font-size: 1.2em;
  `

const ActionButton = styled.button`
  // margin: 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  // make shadow on hover
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    &.cancel {
      background-color: #f0f0f0;
      color: #333;
    }
    &.confirm {
      background-color: #d9534f;
      color: white;
    }
    &.transfer {
      background-color: #5bc0de;
      color: white;
    }
  }
`;

export { Container, ModalContent, Header, MainText, Footer, ActionButton,HeroText };
